<template>
  <v-container>
    <v-row class="pt-3 px-3 justify-space-between">
      <div>
        <div class="toolbar-div pb-3">
          <v-select
            item-color="#006CA1"
            color="#006CA1"
            dense
            class="py-1"
            item-text="text"
            background-color="white"
            v-model="columnsModel"
            :items="columnsItems"
            label="Select columns"
            multiple
            hide-details
            outlined
            :menu-props="{ bottom: true, offsetY: true }"
          >
            <template v-slot:selection="{ attrs, item, select, selected, index }">
              <v-chip
                small
                v-if="index < 2"
                v-bind="attrs"
                color="#EFF2FE"
                close
                label
                @click:close="remove(item)"
              >
                {{ item }}
              </v-chip>
              <span v-if="index === 1 && columnsModel.length > 2" class="grey--text text-caption ml-2">
                (+{{ columnsModel.length - 2 }})
              </span>
            </template>
          </v-select>
        </div>
      </div>
      <div>
         <span v-if="selectedRegs?.length">
          <v-btn
            color="#006CA1"
            class="action-btn"
            v-if="
              selectedRegs[0].status === 'closed' &&
              hasRoles(constants.UPDATE_REGISTRATION_ROLES)
            "
            @click="openDialog()"
            >Change Status to Open</v-btn
           >
          <v-btn
            color="#006CA1"
            class="action-btn"
            v-if="
              selectedRegs[0].status === 'open' &&
              hasRoles(constants.UPDATE_REGISTRATION_ROLES)
            "
            @click="openDialog()"
            >Change Status to Closed</v-btn
          >
          </span>
          <span v-if="!selectedRegs?.length">
            <v-skeleton-loader
              width="200px"
              height="36px">
            </v-skeleton-loader>
          </span>
        </div>
        <div class="text-subtitle-2" style="margin-top: auto; color: #006ca1">
          Found items: {{ itemsFound }}
        </div>
      </v-row>
    <v-dialog hide-overlay width="50%" v-model="dialog" v-if="status_object.changeStatus && selectedRegs?.length">
      <v-container
        v-if="status_object.changeStatus"
        :class="
          selectedRegs[0].status === 'closed'
            ? 'dialog-style-open'
            : 'dialog-style-closed'
        "
      >
        <registrations-change-status
          :status_object="status_object"
          :currentDevice="selectedRegs[0]"
          :validityType="validityType"
          :validityDuration="validity_duration"
          @changeStatusFunction="changeStatusFunction"
          @clearStatusVals="clearStatusVals"
        >
          <template v-slot:globalRadioType>
            <v-radio-group
              row
              v-model="validityType"
              class="mt-2 ml-md-8 ml-xl-0 mt-xl-0"
            >
              <v-radio
                v-for="(radio, index) in radio_status"
                :key="index"
                :label="radio.label"
                :value="radio.value"
                :color="radio.color"
              ></v-radio>
            </v-radio-group>
          </template>
          <template v-slot:globalValidity>
            <v-text-field
              background-color="white"
              outlined
              dense
              v-model="validity_duration"
              label="Validity duration"
            ></v-text-field>
          </template>
        </registrations-change-status>
      </v-container>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import RegistrationsChangeStatus from "./actions/registrations-change-status.vue";
import pgwyClient from "@/api/pgwyClient";
import * as constants from "@/config/constants";
import { REGISTRATION_HEADERS } from "@/config/registration-headers";

export default {
  components: { RegistrationsChangeStatus },
  props: [
  "selectedRegs",
  "itemsFound"
  ],
  data() {
    return {
      columnsModel: REGISTRATION_HEADERS
          .filter((header) => header.defaultVisible && !header.required)
          .map((header) => header.text),
      columnsItems: REGISTRATION_HEADERS
          .filter((header) => !header.required)
          .map((header) => header.text),
      status_object: {
        switchStatus: true,
        changeStatus: false,
        changeStatusLoader: false,
      },
      validityType: "",
      validity_duration: "",
      dialog: false,
      radio_status: [
        { label: "Limited", value: "1", color: "indigo" },
        { label: "Always", value: "2", color: "indigo" },
      ],
      loading: false,
    };
  },
  computed: {
    constants() {
      return constants;
    },
    ...mapGetters(["getRegistrationSearchParams", "getRoles"]),
  },
  watch: {
    columnsModel(columnsModel) {
      // localStorage.setItem('localColumnsModel', JSON.stringify(columnsModel))
      this.$emit("columnsChanged", columnsModel);
    },
  },
  methods: {
    ...mapActions(["updateRegistrations"]),
    hasRoles(roles) {
      return roles.every((role) => this.getRoles.includes(role));
    },
    openDialog() {
      this.loading = false;
      this.status_object.changeStatus = true
      this.status_object.changeStatusLoader = false;
      this.dialog = true;
      this.validityType = "";
      this.validity_duration = "";
    },
    closeDialog() {
      this.dialog = false;
    },
    clearStatusVals() {
      const status = this.selectedRegs[0].status;
      this.status_object.changeStatus = false;

      this.validityType = "";
      return status === "open"
        ? (this.status_object.switchStatus = true)
        : status === "closed"
        ? (this.status_object.switchStatus = false)
        : "";
    },
    changeStatusFunction({ status, validity, device }) {
      this.loading = true;
      this.status_object.changeStatusLoader = true;
      const procId = this.getRegistrationSearchParams.procid;
      const protocol = device.regtype;
      let params = {
        regid: device.regid,
        status,
        validity,
      };

      if (this.validityType === "2") {
        params.validity = "always";
      }
      pgwyClient
        .updateRegistration(procId, protocol, params)
        .then(async () => {
          this.closeDialog();
          this.$emit("actionResponse", { success: true });
          this.$emit("toolbarUpdate", "status");
          await this.updateRegistrations();
        })
        .catch((err) => {
          this.status_object.changeStatusLoader = false;
          this.$emit("actionResponse", {
            message: err.response?.data?.msg || "Could not update registration",
          });
        });
    },
    remove(item) {
      this.columnsModel.splice(this.columnsModel.indexOf(item), 1);
    },
    actionResponse() {},
  },
};
</script>

<style scoped lang="scss">
@import "@/style/main.scss";

::v-deep .v-list-item--link::before {
  background-color: #006ca1;
}
::v-deep .theme--light.v-list-item:hover::before {
  opacity: 0.5;
}
.dialog-style-closed {
  background-color: #ffffff;
  height: 100%;
}
.dialog-style-open {
  background-color: #ffffff;
  height: 100%;
}
.action-btn {
  background-color: #006ca1 !important;
  color: #ffffff;
}
::v-deep .v-chip__content {
  color: #006ca1;
}

.container {
  margin: 0;
}
::v-deep .v-select__slot {
  min-width: 10rem;
}
::v-deep .v-select__slot input {
  display: none;
}
</style>
